(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 768px)';

  function parseRatio(value) {
    var parts = String(value).split('/');
    var w = parseFloat(parts[0]);
    var h = parseFloat(parts[1]);
    if (!w || !h) return 0.5625;
    return w / h;
  }

  function initSection(root) {
    if (!root || root.dataset.swInit === 'true') return;
    root.dataset.swInit = 'true';

    var grid = root.querySelector('[data-sw-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sw-card]'));
    var ctaButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sw-cta-video]'));
    var mql = window.matchMedia(DESKTOP_QUERY);
    var sectionId = root.dataset.sectionId || 'sw';
    var activeCard = null;
    var activeVideo = null;
    var videoHome = null;

    if (!grid || (!cards.length && !ctaButtons.length)) return;

    var existingFs = document.querySelector('.sw-fs[data-sw-fs="' + sectionId + '"]');
    if (existingFs) existingFs.remove();
    var fs = document.createElement('div');
    fs.className = 'sw-fs';
    fs.dataset.swFs = sectionId;
    fs.hidden = true;
    var fsClose = document.createElement('button');
    fsClose.type = 'button';
    fsClose.className = 'sw-fs__close';
    fsClose.setAttribute('aria-label', 'Close video');
    fsClose.textContent = '×';
    fs.appendChild(fsClose);
    document.body.appendChild(fs);

    function storageKey(id) {
      return 'sw-watched:' + sectionId + ':' + id;
    }

    function markWatched(card) {
      card.classList.add('sw-card--watched');
      try {
        sessionStorage.setItem(storageKey(card.dataset.swCard), '1');
      } catch (e) {}
    }

    function restoreWatched() {
      cards.forEach(function (card) {
        try {
          if (sessionStorage.getItem(storageKey(card.dataset.swCard)) === '1') {
            card.classList.add('sw-card--watched');
          }
        } catch (e) {}
      });
    }

    function openFullscreen(video) {
      document.body.classList.add('sw-no-scroll');
      if (video) {
        videoHome = { parent: video.parentNode, next: video.nextSibling };
        video.classList.add('sw-fs__video');
        video.setAttribute('controls', '');
        fs.insertBefore(video, fsClose);
      }
      fs.hidden = false;
    }

    function playVideo(video) {
      if (!video) return;
      try {
        video.currentTime = 0;
      } catch (e) {}
      var playback = video.play();
      if (playback && typeof playback.catch === 'function') {
        playback.catch(function () {});
      }
    }

    function deactivate() {
      if (!activeCard) return;
      var card = activeCard;
      var video = activeVideo;
      activeCard = null;
      activeVideo = null;

      if (video) {
        video.pause();
        video.removeAttribute('controls');
      }

      card.style.gridColumn = '';
      card.style.gridRow = '';
      grid.style.gridTemplateColumns = '';
      grid.classList.remove('sw-grid--active');
      card.classList.remove('sw-card--active');

      if (video && videoHome && video.parentNode === fs) {
        video.classList.remove('sw-fs__video');
        videoHome.parent.insertBefore(video, videoHome.next);
      }
      videoHome = null;
      fs.hidden = true;
      document.body.classList.remove('sw-no-scroll');
    }

    function activate(card) {
      if (activeCard === card) return;
      deactivate();
      activeCard = card;

      var video = card.querySelector('[data-sw-video]');
      activeVideo = video;
      var isDesktop = mql.matches;

      if (isDesktop) {
        var rows = Math.max(1, Math.ceil((cards.length - 1) / 2));
        card.style.gridColumn = '1';
        card.style.gridRow = '1 / span ' + rows;

        var videoRatio = parseRatio(
          getComputedStyle(root).getPropertyValue('--sw-active-ratio')
        );
        var leftFr = Math.max(1, rows * (videoRatio / 1.6));
        grid.style.gridTemplateColumns = leftFr.toFixed(3) + 'fr 1fr 1fr';

        grid.classList.add('sw-grid--active');
        card.classList.add('sw-card--active');
      } else {
        openFullscreen(video);
      }

      playVideo(video);
    }

    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-sw-trigger]');
      var video = card.querySelector('[data-sw-video]');

      if (trigger) {
        trigger.addEventListener('click', function (event) {
          event.stopPropagation();
          if (activeCard === card) {
            deactivate();
          } else {
            activate(card);
          }
        });

        if (video) {
          var preloaded = false;
          trigger.addEventListener('mouseenter', function () {
            if (preloaded || !mql.matches) return;
            preloaded = true;
            video.preload = 'auto';
            video.load();
          });
        }
      }

      if (video) {
        video.addEventListener('ended', function () {
          markWatched(card);
          deactivate();
        });
      }
    });

    ctaButtons.forEach(function (btn) {
      var video = btn.querySelector('[data-sw-video]');
      if (!video) return;

      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        deactivate();
        activeCard = btn;
        activeVideo = video;
        openFullscreen(video);
        playVideo(video);
      });

      var preloaded = false;
      btn.addEventListener('mouseenter', function () {
        if (preloaded) return;
        preloaded = true;
        video.preload = 'auto';
        video.load();
      });

      video.addEventListener('ended', deactivate);
    });

    fsClose.addEventListener('click', deactivate);
    fs.addEventListener('click', function (event) {
      if (event.target === fs) deactivate();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') deactivate();
    });

    document.addEventListener('click', function (event) {
      if (!activeCard || !mql.matches || !fs.hidden) return;
      if (!activeCard.contains(event.target)) deactivate();
    });

    var onBreakpointChange = function () {
      deactivate();
    };
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onBreakpointChange);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(onBreakpointChange);
    }

    restoreWatched();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sw-section]');
    Array.prototype.forEach.call(nodes, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-sw-section]');
    if (root) {
      root.dataset.swInit = '';
      initSection(root);
    }
  });
})();
